export default "__VITE_ASSET__aTdhypxC__"